import { useTranslation } from 'react-i18next';
import { StatCard } from '../molecules/StatCard.js';

interface StatsOverviewProps {
  totalSurveys: number;
  activeSurveys: number;
  totalRespondents: number;
  completionRate: number;
  className?: string;
}

export function StatsOverview({
  totalSurveys,
  activeSurveys,
  totalRespondents,
  completionRate,
  className = '',
}: StatsOverviewProps) {
  const { t } = useTranslation('dashboard');

  return (
    <div className={`grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 ${className}`}>
      <StatCard label={t('stats.total_surveys')} value={totalSurveys} />
      <StatCard label={t('stats.active')} value={activeSurveys} />
      <StatCard label={t('stats.total_respondents')} value={totalRespondents} />
      <StatCard label={t('stats.completion_rate')} value={`${completionRate}%`} />
    </div>
  );
}
